import { useState, type ChangeEvent } from 'react';

export const useSearchTerms = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return { searchTerm, handleSearch };
};
